const whiteList = [
    '/login',
    '/register',
	'/home',
	'/search',
	'/goods',
	'/goods/goodsList',
	'/goods/goodsDetail',
	'/order'
]

export default whiteList